class MaxHeight {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.run()
        window.addEventListener('resize', () => {
            this.run()
        })
    }
    run() {
        document.querySelectorAll('[data-max-height]').forEach((el) => {
            if (0 === el.children.length) {
                return;
            }
            const maxHeight = el.children[0].getBoundingClientRect().height
            el.style.setProperty('--max-height', maxHeight+'px');

            console.log(maxHeight);
        })
    }
}

export default MaxHeight